import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";
import React from "react";

export const PersonAdd = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue7fe'}</MuiIcon>
    );
}